import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-290" data-mp="3k06wnu4a0ry9">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.14em] sm:text-sm ${dark ? "text-gold" : "text-gold-dark"}`} data-id="element-291" data-mp="3k0f6fd53rh58">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-[30px] font-bold leading-[1.12] sm:text-4xl md:text-5xl ${dark ? "text-white" : "text-navy"}`} data-id="element-292" data-mp="giewhsfzl1oz">
        {title}
      </h2>
      {subtitle && <p className={`mx-auto mt-4 max-w-2xl text-[17px] leading-relaxed sm:text-lg ${dark ? "text-white/75" : "text-muted"}`} data-id="element-293" data-mp="6s2fubbalso4">
          {subtitle}
        </p>}
    </div>;
}